import {
    get_datiUserInfo
} from "@/api/api.user.js";

import storage from "@/services/storage";

const user = {
    namespaced: true,

    state: {
        user: '',
        role: -1,
        mail: '',
        menu: [],
        licenzaStato: -1,
        emailConfirmed: false
    },

    mutations: {
        SET_USER: (state, user) => {
            state.user = user.username
            state.role = user.roleID
            state.menu = user.menu
            state.mail = user.eMail
            state.licenzaStato = user.licenzaStato
            state.emailConfirmed = user.emailConfirmed
        },
    },

    actions: {

        userInfo({
            commit
        }) {

            return new Promise((resolve, reject) => {

                get_datiUserInfo().then(resp => {

                    commit("SET_USER", resp.data)

                    resolve(resp)

                }).catch(err => {

                    reject(err)
                    storage.logout()
                })
            })

        },


    },

    getters: {
        getRole: state => state.role,

        getTitolo: state => link => {

            let itemFind = state.menu.find(x => x.Link === link);
            if (itemFind)
                return itemFind.Text + '|' + itemFind.Img;

            return ""
        },

        getNome: state => {
            return state.user
        },
        getMail: state => {
            return state.mail
        },

        getLicenzaStato: (state) => state.licenzaStato ?? 0,
        getEmailConfirmata: (state) => state.emailConfirmed ?? false,

    }
}


export default user